<!-- </div> -->
<!-- content -->

<nav class="mobile-footer-menu">
	<ul>
		<li>
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/dashboard'] : ['/guest/dashboard']"><img class="icon-sports" src="https://speedcdn.io/assets/king-v8/icons/trophy.svg" />Sports</a>
		</li>
		<li>
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/inplay'] : ['/guest/inplay']"><img class="icon-inplay" src="https://speedcdn.io/assets/king-v8/icons/timer.svg" />In-Play</a>
		</li>
		<!-- class="main-nav" -->
		<li class="main-nav">
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/dashboard'] : ['/home']"><img class="icon-home" src="https://speedcdn.io/assets/king-v8/icons/home.svg" />Home</a>
		</li>
		<li>
			<!-- <a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/casino'] : ['/guest/casino']"><img class="icon-pin" src="assets/img/playing-cards.svg" />Casino</a> -->
			<a *ngIf="_common.getToken()" class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]=" ['/multi-market']"><img class="icon-pin" src="https://speedcdn.io/assets/king-v8/icons/pin-white-footer.svg" />Multi Market</a>
			<a *ngIf="!_common.getToken()" class="ui-link" routerLinkActive="active" href="javascript:void(0)" (click)="openLogin()"><img class="icon-pin" src="https://speedcdn.io/assets/king-v8/icons/pin-white-footer.svg" />Multi Market</a>
		</li>
		<li>
			<a *ngIf="_common.getToken()" class="ui-link" routerLinkActive="active" href="javascript:void(0)" routerLink="/mobile-menu"><img class="icon-account" src="https://speedcdn.io/assets/king-v8/icons/user.svg" />Account</a>
			<a *ngIf="!_common.getToken()" class="ui-link" routerLinkActive="active" href="javascript:void(0)" (click)="openLogin()"><img class="icon-account" src="https://speedcdn.io/assets/king-v8/icons/user.svg" />Account</a>
		</li>
	</ul>
</nav>
<!-- Footer Start -->
<!-- <footer class="footer">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-6">
				<script>document.write(new Date().getFullYear())</script> &copy; UBold theme by <a href="">Coderthemes</a>
			</div>
			<div class="col-md-6">
				<div class="text-md-end footer-links d-none d-sm-block">
					<a href="javascript:void(0);">About Us</a>
					<a href="javascript:void(0);">Help</a>
					<a href="javascript:void(0);">Contact Us</a>
				</div>
			</div>
		</div>
	</div>
</footer> -->
<!-- end Footer -->

<!--<div class="home-footer inner-footer">-->
<!--    <div class="container">-->
<!--        <div class="row">-->
<!--            <div class="col-md-3">-->
<!--                <img class="img-fluid hf-logo" src="/assets/img/{{env.host.name}}/logo.png" alt="">-->
<!--            </div>-->
<!--            <div class="col-md-3">-->
<!--                <h2>game therapy</h2>-->
<!--                <div class="gt">-->
<!--                    <a><img class="img-fluid" src="assets/img/18-plus.png"></a>-->
<!--                    <a><img class="img-fluid" src="assets/img/gt.png"></a>-->
<!--                    <a><img class="img-fluid" src="assets/img/gamecare.png"></a>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="col-md-3">-->
<!--                <h2>scane QR code</h2>-->
<!--                <img class="img-fluid scanecode" src="assets/img/scanecode.png">-->
<!--            </div>-->
<!--            <div class="col-md-3">-->
<!--                <h2>100% safe</h2>-->
<!--                <img class="img-fluid scanecode" src="assets/img/ssl.png">-->
<!--                <p>Protected connection and encrypted data.</p>-->
<!--            </div>-->
<!--            <div class="col-12 text-center">-->
<!--                <ul>-->
<!--                    <li><a>about</a></li>-->
<!--                    <li><a>privacy</a></li>-->
<!--                    <li><a>rules</a></li>-->
<!--                </ul>-->
<!--            </div>-->
<!--            <div class="col-12">-->
<!--                <p class="home-copyright">© Copyright Mango777. All rights reserved</p>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->

<!-- </div> -->

<!-- ============================================================== -->
<!-- End Page content -->
<!-- ============================================================== -->



